<ng-template #leagueTemplate let-item let-favouriteTracking="favouriteTracking" let-isTopCompetition="isTopCompetition">
    @if (isTopCompetition) {
        <ds-divider />
    }
    <ms-list-item
        msTrackReferringActionDirective
        [trackingValue]="trackingValue()"
        [cleanAfterTrack]="cleanedAfterTrack()"
        [arrow]="false"
        [iconSize]="'16'"
        [class.us-logo]="hasCompetitionLogo(item.sport, item.id, item.imageProfile)"
        [count]="getCount(isTopCompetition, item.count)"
        [href]="treeItemNavigation ? null : item.href"
        [icon]="item.icon"
        [title]="item.title"
        [boldTitle]="item.active"
        [subTitle]="getSubTitle(isTopCompetition, item)"
        [isShowBorder]="false"
        [isActive]="item.active"
        [badge]="true"
        [showStartSlot]="!!item.icon || !showFavourite"
        (itemClicked)="onTreeItemClick(item)">
        @if (!item.icon && !showFavourite) {
            <span item-icon>
                <ms-favourite-league-toggle
                    class="favourite-icon"
                    [id]="getItemFavouriteId(item)"
                    [name]="item.title"
                    [sport]="item.sport"
                    [tracking]="favouriteTracking" />
            </span>
        }
        <span badge class="badge-alignment">
            @if (isPriceBoost(!!item.priceBoostCount)) {
                <ms-priceboost-count-signpost [count]="item.priceBoostCount" />
            }
            @if (isPromoted(item)) {
                <ms-promotion-badge />
            }
        </span>
        @if (isLeagueOrVirtualGroup(item)) {
            @if (hasCompetitionLogo(item.sport, item.id, item.imageProfile)) {
                <span competition-logo class="logo-alignment">
                    <ms-competition-logo [sportId]="item.sport" [leagueId]="item.id" [imageProfile]="item.imageProfile" />
                </span>
            }
        }
    </ms-list-item>
</ng-template>

<ng-template #topCompetitionTemplate let-item>
    <ng-container *ngTemplateOutlet="leagueTemplate; context: { $implicit: item, favouriteTracking: favouriteTracking, isTopCompetition: true }" />
</ng-template>

<ng-template #treeCompetitionTemplate let-item>
    <ng-container *ngTemplateOutlet="leagueTemplate; context: { $implicit: item }" />
</ng-template>

<ms-item-tree *rxIf="all" [tree]="[all]" [msAutomation]="{ id: 'interval-competitions', type: 'navigation' }" (toggle)="toggleExpandedAll($event)" />
<ms-item-tree
    *rxIf="top"
    [tree]="[top]"
    [msAutomation]="{ id: 'top-competitions', type: 'navigation' }"
    [leafTemplate]="topCompetitionTemplate"
    (toggle)="toggled(treeSource.Top, top, $event)" />

<ms-calendar-item-list *rxIf="calendarIntervals?.length" [calendarIntervals]="calendarIntervals" [location]="timeFrameLocation" />

<ms-item-tree
    *rxIf="tree"
    [tree]="[tree]"
    [class]="eSportsLobby ? 'esports-tree' : 'all-competitions'"
    [msAutomation]="{ id: 'all-competitions', type: 'navigation' }"
    [leafTemplate]="treeCompetitionTemplate"
    [esportsItemTemplate]="eSportsLobby"
    (toggle)="toggled(treeSource.All, tree, $event)" />
